 <script> 

import appConfig from "@/app.config";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
 
import YanitlarGrafik from "./YanitlarGrafik.vue";
/**
 * Form-element component
 */
export default {
  mixins: [Api, Sabit],
  props: ["Form","AnktAnketId","AnketFilterText"],
  page: {
    title: "Anket Oluştur",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {  YanitlarGrafik },
  data() {
    return {
      title: this.$t("CreateAnket.Title"),
      items: [
        {
          text: this.$t("CreateAnket.Title"),
          active: true,
        },
      ],
       Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FormData: [],
      FormJson: [], 
      DataGrafik:[],
      DataGrafikSutun:[],
      DataGrafikTable:[],
      DoluKayitSayisi:0,
      CevapSayisi:0,
      Stadartsapma:"",
      Ortalama:"",
      Medyan:"",
      GenelMemnuniyetOrani: "",
      boskayitsayisi: 0
 
     }  
  },
  watch: {
    AnketFilterText() {
      this.Get()
    },
  },
  methods: {
 
sortedArray: function (){
  return this.DataGrafikTable.slice().sort(function(a, b){
    return (a.Title > b.Title) ? 1 : -1;
  });
},
    Get() {
      
      this.DataGrafik = []
      this.DataGrafikTable = []
  
  


    let Data = "";
  if(this.Form.type == 'input' || this.Form.type == 'date' || this.Form.type == 'time'  || this.Form.type == 'textarea' || this.Form.type == 'file'){
      
      
       let Data={
        Filter:"select COUNT(*) as DoluKayitSayisi from anktanketcevap WHERE anketid='"+this.AnktAnketId+"'"
        + this.AnketFilterText
     } 
   
   this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
          //console.log(res);
           this.CevapSayisi=res;
    
      Data={
        Filter:"select COUNT(*)  from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' and cevap->'"+this.Form.Id+"' ->> 'Cevap' !=''"
      + this.AnketFilterText
      } 
      
       this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
          if(!res){res=0;}
          // console.log(res);
          this.DoluKayitSayisi=res
           this.DataGrafik.push(
             { 
               value: res, 
               name: 'Dolu Olan Kayıt Sayısı: '+res+' (%'+((res/this.CevapSayisi)*100).toFixed(2)+')',
               namefooter: 'Dolu Olan Kayıt Sayısı: '
            },
             { 
               value: this.CevapSayisi-res, 
               name: 'Girilmeyen Kayıt Sayısı '+(this.CevapSayisi-res)+' (%'+(((this.CevapSayisi-res)/this.CevapSayisi)*100).toFixed(2)+')',
               namefooter: 'Girilmeyen Kayıt Sayısı'
            }
           );
           this.DataGrafikTable.push(
             { Title: "Dolu Kayıt Sayısı", Value: res, Oran: ((res/this.CevapSayisi)*100).toFixed(2)  },
             { Title: "Yanıt vermeyenler", Value: this.CevapSayisi-res, Oran: (((this.CevapSayisi-res)/this.CevapSayisi)*100).toFixed(2)  },
           );
          });
              });
    }else if(this.Form.type == 'radiobutton' || this.Form.type == 'combobox'){
      let Data={
        Filter:"select COUNT(*) as DoluKayitSayisi from anktanketcevap WHERE anketid='"+this.AnktAnketId+"'"
     + this.AnketFilterText
     } 
   this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => {
 let Data={
        Filter:"select COUNT(*)  from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' and cevap->'"+this.Form.Id+"' ->> 'Cevap' =''"
    + this.AnketFilterText
    } 
   this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(boskayitsayisi => { 
    console.log(boskayitsayisi);
            this.boskayitsayisi = 0;
           this.CevapSayisi=res;
     /*     this.DataGrafik.push(
             { 
               value: this.boskayitsayisi, 
               name: "Yanıt vermeyenler"+': 0'+ this.boskayitsayisi+' (%'+((this.boskayitsayisi/this.CevapSayisi)*100).toFixed(2)+')',
               namefooter: "Yanıt vermeyenler"
            }
           );

           this.DataGrafikTable.push(
             { Title: "Yanıt vermeyenler", Value: this.boskayitsayisi, Oran: ((this.boskayitsayisi/this.CevapSayisi)*100).toFixed(2)  }
           ); */
          //console.log(res);
      for(var i =0; i<this.Form.options.length; i++){
        let Deger =this.Form.options[i].value
      Data={
        Filter:"select COUNT(*)  from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' and cevap->'"+this.Form.Id+"' ->> 'Cevap' ='"+this.Form.options[i].Id+"'"
    + this.AnketFilterText
    } 
    
       this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
          // console.log(res); 
          this.DoluKayitSayisi=res
           this.DataGrafik.push(
             { 
               value: res, 
               name: Deger+': '+res+' (%'+((res/(this.CevapSayisi-boskayitsayisi))*100).toFixed(2)+')',
               namefooter: Deger
            }
           );
           this.DataGrafikTable.push(
             { Title: Deger, Value: res, Oran: ((res/(this.CevapSayisi-boskayitsayisi))*100).toFixed(2)  }
           );
           
      });
      }
             });  });
    }else if(this.Form.type == 'rangeslider'){
           let Data={
        Filter:"select COUNT(*) as DoluKayitSayisi from anktanketcevap WHERE anketid='"+this.AnktAnketId+"'"
      + this.AnketFilterText
      } 
   this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
          //console.log(res);
           this.CevapSayisi=res;
      for( var j =0; j<11; j++){ 
      Data={
        Filter:"select COUNT(*)  from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' and cevap->'"+this.Form.Id+"' ->> 'Cevap' ='"+j+"'"
      + this.AnketFilterText
      } 
      if(j!=10){

       j = " "+j;
      }
     
      const Name = j + " Kayıt Sayısı" 
     
       this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
          // console.log(res);
          
          this.DoluKayitSayisi=res
           this.DataGrafik.push(
             { value: res, 
              name: Name+': '+res+' (%'+((res/this.CevapSayisi)*100).toFixed(2)+')',
               namefooter: Name
              }
           );
           this.DataGrafikTable.push(
             { Title: Name, Value: res, Oran: ((res/this.CevapSayisi)*100).toFixed(2)  }
           );

          
      });
      }
      
      });
    }else if(this.Form.type == 'CoktanSecmeliTablo'){
       let Data={
        Filter:"select COUNT(id) from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' "
     + this.AnketFilterText
     }  
       this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
         
     this.CevapSayisi = res
    
      for(let i =0; i<this.Form.options.Satir.length; i++){ 
        
          for(let j =0; j<this.Form.options.Sutun.length; j++){ 


          Data={
          Filter:"select COUNT(id) from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' and cevap->'"+this.Form.Id+"'->'Cevap'->>'"+this.Form.options.Satir.[i].Id+"' = '"+this.Form.options.Sutun.[j].Id+"'"
          + this.AnketFilterText
          }  
     
          this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => {  
          // console.log(res); 
           //this.CevapSayisi = res
           this.DataGrafik.push(
             { Id: this.Form.options.Satir[i].Id, 
             value: res, 
              name: this.Form.options.Sutun[j].value+': '+res+' (%'+((res/this.CevapSayisi)*100).toFixed(2)+')',
               namefooter: this.Form.options.Sutun[j].value 
                }
           );
           this.DataGrafikTable.push(
            {  Id: this.Form.options.Satir[i].Id, Title: this.Form.options.Sutun[j].value , Value: res, Oran: ((res/this.CevapSayisi)*100).toFixed(2)  }
           ); 
          
      });
      }

    }
      });
    }
    
    else if(this.Form.type == 'OnayKutuluTablo'){
        Data={
        Filter:"select COUNT(id) from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' "
      + this.AnketFilterText
      }  
       this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
         
     this.CevapSayisi = res
          
      for(let i =0; i<this.Form.options.Satir.length; i++){
        for(let j =0; j<this.Form.options.Sutun.length; j++){
 
 
        Data={
        Filter:"select COUNT(id) from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' and (cevap->'"+this.Form.Id+"'->'Cevap'->'"+this.Form.options.Satir.[i].Id+"'->>'"+this.Form.options.Sutun.[j].Id+"')::boolean is true"
      + this.AnketFilterText
      }  
       this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
         
          // console.log(res); 
          this.DoluKayitSayisi=res
           this.DataGrafik.push(
             { Id: this.Form.options.Satir[i].Id,value: res,  
                name: this.Form.options.Sutun[j].value+': '+res+' (%'+((res/this.CevapSayisi)*100).toFixed(2)+')',
               namefooter: this.Form.options.Sutun[j].value
             }
           );
           this.DataGrafikTable.push(
             { Id: this.Form.options.Satir[i].Id,Title:  this.Form.options.Sutun[j].value +" Kayıt Sayısı", Value: res, Oran: ((res/this.CevapSayisi)*100).toFixed(2)  }
           );

          
      });
      }

    }
     });
    }
    
    else if(this.Form.type == 'checkbox' ){ 
      let Data={
        Filter:"select COUNT(*) as DoluKayitSayisi from anktanketcevap WHERE anketid='"+this.AnktAnketId+"'"
      + this.AnketFilterText
      } 
       
   this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
          //console.log(res);
           this.CevapSayisi=res;

      for(let i =0; i<this.Form.options.length; i++){
        let Deger =this.Form.options[i].value
      Data={
        Filter:"select COUNT(id) from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' and (cevap->'"+this.Form.Id+"'->'Cevap'->>'"+this.Form.options[i].Id+"')::boolean is true"
     + this.AnketFilterText
     }  
       this.ActionsPost({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => {  
          // console.log(res); 
          this.DoluKayitSayisi=res
           this.DataGrafik.push(
             { value: res,  
             name: Deger +' Kayıt Sayısı'+': '+res+' (%'+((res/this.CevapSayisi)*100).toFixed(2)+')',
               namefooter: Deger +" Kayıt Sayısı"
               }
           );
           this.DataGrafikTable.push(
             { Title: Deger+" Kayıt Sayısı", Value: res, Oran: ((res/this.CevapSayisi)*100).toFixed(2)  }
           );
        
      });   
      }});
     }  
  
    },
    Statics(SoruId){
 
      
      let Sorgu = "select cevap ->'"+SoruId+"' ->> 'Cevap' as cevap from anktanketcevap where anketid='" + this.AnktAnketId + "' and cevap ->'"+SoruId+"' ->> 'Cevap' != ''";
 
      let Data = {
        filter: Sorgu,
      }; 
 this.ActionsPost({
        Service: "AnktAnketCevap/Statics",
        Data: Data,
      }).then((res) => {
        //console.log(res);
        if(res){
          this.Stadartsapma = res.Stadartsapma
          this.Ortalama = res.Ortalama
          this.Medyan = res.Medyan
          this.GenelMemnuniyetOrani = res.GenelMemnuniyetOrani
        }
      });
    }
    
    
  },
  created() {
    
  },
  mounted(){ }, 
};
</script>
<style >
.dropdown-menu.show {
  overflow-y: scroll !important;
  height: 200px !important;
}
</style>
<template>
  <div>
    <div
      class="row"
      v-if="Form.type != 'OnayKutuluTablo' && Form.type != 'CoktanSecmeliTablo'"
    >
      <div class="col-6">
        <h5>
          {{ $t("AnktDetay.Page.YanitlarTab.Soru") }} {{ Form.props.title }}
        </h5>
        <YanitlarGrafik :Data="DataGrafik" />
      </div>
      <div class="col-6">
        <div class="row" v-if="DataGrafikTable.length != 0">
          <div class="col-4">
            <b> {{ $t("AnktDetay.Page.YanitlarTab.Alan") }}</b>
          </div>
          <div class="col-4">
            <b> {{ $t("AnktDetay.Page.YanitlarTab.Deger") }}</b>
          </div>
          <div class="col-4">
            <b> {{ $t("AnktDetay.Page.YanitlarTab.Oran") }}</b>
          </div>
        </div>
        <div
          class="row"
          v-for="(GrafikTable, GrafikTableIndex) in sortedArray()"
          :key="GrafikTableIndex"
        >
          <div class="col-4">
            {{ GrafikTable.Title }}
          </div>
          <div class="col-4">
            {{ GrafikTable.Value }}
          </div>
          <div class="col-4">% {{ GrafikTable.Oran | formatYuzde }}</div>
        </div>
        <br />
        <div v-if="Form.type == 'rangeslider' || Form.config.type == 'number'">
          <button
            type="button"
            class="btn btn-primary btn-rounded mb-2 me-2"
            @click="Statics(Form.Id)"
          >
            {{ $t("AnktDetay.Page.YanitlarTab.IstatistikHesaplaBtn") }}
          </button>

          <div class="row" v-if="Stadartsapma">
            <div class="col-3">
              <b>{{ $t("AnktDetay.Page.YanitlarTab.GenelMemnuniyetOrani") }}</b>
            </div>
            <div class="col-3">
              <b>{{ $t("AnktDetay.Page.YanitlarTab.StadartSapma") }}</b>
            </div>
            <div class="col-3">
              <b>{{ $t("AnktDetay.Page.YanitlarTab.Ortalama") }}</b>
            </div>
            <div class="col-3">
              <b>{{ $t("AnktDetay.Page.YanitlarTab.Medyan") }}</b>
            </div>
          </div>
          <div class="row" v-if="Stadartsapma">
            <div class="col-3">%{{ GenelMemnuniyetOrani }}</div>
            <div class="col-3">{{ parseFloat(Stadartsapma).toFixed(6) }}</div>
            <div class="col-3">{{ Ortalama }}</div>
            <div class="col-3">{{ Medyan }}</div>

          </div>
        </div>
      </div>
    </div>

    <div
      v-if="Form.type == 'OnayKutuluTablo' || Form.type == 'CoktanSecmeliTablo'"
    >
      <div
        class="row"
        v-for="Satirlar in Form.options.Satir"
        :key="Satirlar.Id"
      >
        <div class="col-6">
          <h5>
            {{ $t("AnktDetay.Page.YanitlarTab.Soru") }} {{ Form.props.title }} /
            {{ Satirlar.value }}
          </h5>
          <YanitlarGrafik
            :Data="
              DataGrafik.filter((notification) =>
                notification.Id.includes(Satirlar.Id)
              )
            "
          />
        </div>
        <div class="col-6">
          <div class="row" v-if="DataGrafikTable.length != 0">
            <div class="col-4">
              <b> {{ $t("AnktDetay.Page.YanitlarTab.Alan") }}</b>
            </div>
            <div class="col-4">
              <b> {{ $t("AnktDetay.Page.YanitlarTab.Deger") }}</b>
            </div>
            <div class="col-4">
              <b> {{ $t("AnktDetay.Page.YanitlarTab.Oran") }}</b>
            </div>
          </div>
          <div
            class="row"
            v-for="(GrafikTable, GrafikTableIndex) in DataGrafikTable.filter(
              (notification) => notification.Id.includes(Satirlar.Id)
            )"
            :key="GrafikTableIndex"
          >
            <div class="col-4">
              {{ GrafikTable.Title }}
            </div>
            <div class="col-4">
              {{ GrafikTable.Value }}
            </div>
            <div class="col-4">% {{ GrafikTable.Oran | formatYuzde }}</div>
          </div>
          <br />
          <div
            v-if="Form.type == 'rangeslider' || Form.config.type == 'number'"
          >
            <button
              type="button"
              class="btn btn-primary btn-rounded mb-2 me-2"
              @click="Statics(Form.Id)"
            >
              {{ $t("AnktDetay.Page.YanitlarTab.IstatistikHesaplaBtn") }}
            </button>

            <div class="row" v-if="Stadartsapma">
              <div class="col-4">
                <b>{{ $t("AnktDetay.Page.YanitlarTab.StadartSapma") }}</b>
              </div>
              <div class="col-4">
                <b>{{ $t("AnktDetay.Page.YanitlarTab.Ortalama") }}</b>
              </div>
              <div class="col-4">
                <b>{{ $t("AnktDetay.Page.YanitlarTab.Medyan") }}</b>
              </div>
            </div>
            <div class="row" v-if="Stadartsapma">
              <div class="col-4">{{ parseFloat(Stadartsapma).toFixed(6) }}</div>
              <div class="col-4">{{ Ortalama }}</div>
              <div class="col-4">{{ Medyan }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>